import * as actionTypes from "../actions/actionsTypes";


const initialState = {
  selectedDate: {
    data: {
        "date": null,
    }
  },
};

export const dateReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SELECTED_DATE:
          return {
            ...state,
            selectedDate: action.payload,
          };
        default:
          return state;
      }
    };
    